import { PieChart, Pie, Tooltip } from 'recharts';
import { AlertIcon } from '../assets/svgImages';
import { Tooltip as ReactToolTip } from 'react-tooltip';
import { DoughnutChartProps } from '../interface/interface';

const CustomTooltip = ({ active, payload, unit }: any) => {
  if (active && payload?.length) {
    const { fill } = payload[0].payload;
    return (
      <div className="bg-secondary-pink-50 px-2 py-1 rounded-full text-primary-blue-500 text-base">
        <p className="flex items-center">
          <span
            className="w-3.5 h-3.5 rounded-full mr-2 block"
            style={{
              backgroundColor: fill,
            }}
          ></span>
          <span>{`${payload[0].value}${unit}`}</span>
        </p>
      </div>
    );
  }

  return null;
};

const CustomLegend = ({ data, unit }: DoughnutChartProps) => (
  <div className="ml-4">
    {data.map((entry, index) => (
      <div key={`legend-${index + 1}`} className="flex items-baseline mb-5">
        <div
          className="w-2.5 h-2.5 rounded-full mr-1.5"
          style={{
            backgroundColor: entry.fill,
          }}
        ></div>
        <div className="flex justify-between w-full text-primary-blue-500 text-sm lg:text-base font-regular">
          <div>
            <p>{entry.name}</p>
            {entry?.subProducts?.map((subentry: string, index: number) => (
              <div
                key={`legend-${index + 1}`}
                className="flex items-center mt-1"
              >
                <a data-tooltip-id={`${index + 1}`}>
                  <AlertIcon className="fill-secondary-pink-500 cursor-pointer" />
                </a>

                <ReactToolTip className="z-[200]" id={`${index + 1}`}>
                  <p>Substitute Product</p>
                </ReactToolTip>
                <p className="ml-1">{subentry}</p>
              </div>
            ))}
          </div>

          <p>
            {entry.value}
            {unit}
          </p>
        </div>
      </div>
    ))}
  </div>
);

const DoughnutChart = ({ data, unit }: DoughnutChartProps) => {
  const usedQty = data?.filter((item) => item.name !== 'Qty remaining');
  const sumValue: number = usedQty
    ?.filter((x) => x.name !== 'Qty remaining')
    ?.reduce((acc, curr) => acc + curr.value, 0);
  return (
    <div className="flex justify-between flex-col-reverse lg:flex-row">
      <div className="w-full lg:w-1/2 flex flex-col border border-secondary-pink-700 rounded p-4 lg:px-10 lg:py-6">
        <p className="text-xl font-semibold text-secondary-pink-700 mb-5">
          Medicines consumed this month
        </p>
        <div>
          <CustomLegend data={data} unit={unit} />
        </div>
      </div>
      <div
        className="w-full lg:w-2/5 relative flex justify-center"
        style={{ maxHeight: '400px' }}
      >
        <p
          className="absolute text-center top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 
        flex flex-col text-4xl text-primary-blue-500 font-bold"
        >
          <span>
            {sumValue}
            {unit}
          </span>
          <span className="text-grey-500 text-sm font-regular"> used</span>
        </p>
        <PieChart width={400} height={400}>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={180}
            innerRadius={120}
            label
          />
          <Tooltip content={<CustomTooltip unit={unit} />} />
        </PieChart>
      </div>
    </div>
  );
};

export default DoughnutChart;
